// removed by extract-text-webpack-plugin
module.exports = {"page":"src-styles----app-module---page---1lltx","content":"src-styles----app-module---content---2VLat"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/app.module.styl
// module id = 567
// module chunks = 114276838955818